export class Attribute {
    ID: number;
    Name: string;
}

export default Attribute;